import { Route, Routes, useLocation } from 'react-router-dom'
import VendorWizardStepper from 'vendors/vendorWizard/VendorWizardStepper'
import VendorWizardUserBasicInfo from 'vendors/vendorWizard/userBasicInfoStep/VendorWizardUserBasicInfoStep'
import VendorWizardSelectCompanyStep from 'vendors/vendorWizard/selectCompanyStep/VendorWizardSelectCompanyStep'
import VendorInformationStep from 'vendors/vendorWizard/vendorInformationStep/VendorInformationStep'
import VendorContactInfoStep from 'vendors/vendorWizard/vendorContactInfoStep/VendorContactInfoStep'
import VendorWorkRegionStep from 'vendors/vendorWizard/vendorWorkRegionStep/VendorWorkRegionStep'
import VendorServicesStep from 'vendors/vendorWizard/vendorServicesStep/VendorServicesStep'
import VendorWizardDone from 'vendors/vendorWizard/vendorDoneStep/VendorWizardDone'
import { VendorWizardProvider } from 'vendors/vendorWizard/VendorWizardContext'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

const VendorFirstWizard = () => {
  const location = useLocation()
  const url = location.pathname.split('/wizard')[0] + '/wizard'
  const { t } = useTranslation()

  const steps = [
    { step: '/user', label: t('your-information') },
    { step: '/company', label: t('company-selection') },
    { step: '/info', label: t('basic-information') },
    { step: '/contact', label: t('contact-information') },
    { step: '/services', label: t('services') },
    { step: '/region', label: t('regions-of-operation') }
  ]

  return (
    <Routes>
      <Route path="done" element={<VendorWizardDone />} />
      <Route path="*" element={
        <>
          <VendorWizardStepper steps={steps} />
          <Box sx={{ width: '100%', maxWidth: '650px', alignSelf: 'center' }}>
            <VendorWizardProvider>
              <Routes>
                <Route path="user" element={<VendorWizardUserBasicInfo baseUrl={url} />} />
                <Route path="company" element={<VendorWizardSelectCompanyStep baseUrl={url} />} />
                <Route path="info" element={<VendorInformationStep baseUrl={url} />} />
                <Route path=":vendorId/contact" element={<VendorContactInfoStep baseUrl={url} />} />
                <Route path=":vendorId/services" element={<VendorServicesStep baseUrl={url} />} />
                <Route path=":vendorId/region" element={<VendorWorkRegionStep baseUrl={url} />} />
              </Routes>
            </VendorWizardProvider>
          </Box>
        </>
      } />
    </Routes>
  )
}

export default VendorFirstWizard
